import React, { useState, useCallback } from 'react';
import { ButtonPrimary } from '@spotify-internal/creator-tape';
import * as Sentry from '@sentry/browser';
import { ErrorPage } from '../shared/components/ErrorPage';
import { ErrorBoundary } from '../features/errorLogging';

function AppError({ eventId }: { eventId: string }) {
  return (
    <ErrorPage
      description={`Error id: ${eventId}`}
      action={
        <ButtonPrimary onClick={() => window.location.reload()}>
          Reload
        </ButtonPrimary>
      }
    />
  );
}

export function AppErrorBoundary({ children }: { children: React.ReactNode }) {
  const [eventId, setEventId] = useState('');

  const logger = useCallback(error => {
    Sentry.withScope(scope => {
      scope.setTag('logger', 'App');
      scope.setLevel(Sentry.Severity.Fatal);
      setEventId(Sentry.captureException(error));
    });
  }, []);

  return (
    <ErrorBoundary logger={logger} fallback={<AppError eventId={eventId} />}>
      {children}
    </ErrorBoundary>
  );
}
